import { ChangeEvent, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { TERMS_AND_CONDITIONS_URL } from '../../../../constants';
import {
  useAuthProtectedAction,
  useCheckoutTopUpSession,
} from '../../../../hooks';
import useCreditPrice from '../../../../hooks/useCreditPrice';
import {
  selectIsSubscribed,
  selectDesiredCreditsAmount,
} from '../../../../store/account/selectors';
import {
  StyledButton,
  StyledCheckbox,
  StyledCheckboxText,
  StyledFormGroup,
  StyledFormGroupLabel,
  StyledLink,
} from './styled';

const PurchaseButton = () => {
  const { createSession, isLoading } = useCheckoutTopUpSession();
  const price = useCreditPrice();
  const [isAgreed, setIsAgreed] = useState(true);

  const quantity = useSelector(selectDesiredCreditsAmount);
  const isSubscribed = useSelector(selectIsSubscribed);

  const handlePurchase = useCallback(() => {
    createSession({
      quantity,
      priceId: price?.id || '',
    });
  }, [createSession, quantity, price?.id]);

  const handleClick = useAuthProtectedAction(handlePurchase);

  const handleAgreementChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsAgreed(event.target.checked);
  };

  return (
    <StyledFormGroup>
      <StyledFormGroupLabel>
        <StyledCheckbox
          disabled={isSubscribed}
          checked={isAgreed}
          onChange={handleAgreementChange}
          name="agreement"
        />
        <StyledCheckboxText>
          By using Loudly API, you hereby consent to our standard{' '}
          <StyledLink href={TERMS_AND_CONDITIONS_URL} target="_blank">
            API Licensing Agreement
          </StyledLink>
        </StyledCheckboxText>
      </StyledFormGroupLabel>
      <StyledButton
        loading={isLoading}
        onClick={handleClick}
        disabled={!isAgreed || isLoading || isSubscribed}
      >
        Buy Now
      </StyledButton>
    </StyledFormGroup>
  );
};

export default PurchaseButton;
